module.exports = __webpack_public_path__ + "static/media/hotdog.0aafbf4b.png";